module.exports = ".fourzerofour__container {\n  min-width: 100%;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/404/404.component.scss
// module id = ./src/app/pages/404/404.component.scss
// module chunks = main